// extracted by mini-css-extract-plugin
export default {"tabNavigatorpreview":"dc082af24ee506be2815","tabnavigator":"a50f5457725713c56880","header":"c18582c1d2643cd73ac7","tabview":"d2f807ccc886f9a6da16"};